module.exports = {
	"ha": "viha",
	"id": 1.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Island Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019",
					"2019",
					"2019",
					"2019",
					"2020",
					"2020",
					"2020",
					"2020",
					"2021",
					"2021",
					"2021",
					"2021",
					"2022",
					"2022"
				],
				"tickPositions": [
					0,
					2,
					6,
					10,
					14,
					18
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2.258,
					2.297,
					2.415,
					2.546,
					2.552,
					2.672,
					2.803,
					2.826,
					2.959,
					2.78,
					2.572,
					1.56,
					1.906,
					2.249,
					2.35,
					2.239,
					2.293,
					2.153,
					2.163,
					{
						"y": 2.216,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.44,
					0.49,
					0.522,
					0.582,
					0.591,
					0.605,
					0.571,
					0.569,
					0.595,
					0.664,
					0.534,
					0.291,
					0.479,
					0.551,
					0.502,
					0.436,
					0.473,
					0.504,
					0.524,
					{
						"y": 0.511,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					3.882,
					3.93,
					4.327,
					4.038,
					3.977,
					4.284,
					4.34,
					4.119,
					4.234,
					4.222,
					3.653,
					2.278,
					3.096,
					3.149,
					3.271,
					3.09,
					2.842,
					2.678,
					2.685,
					{
						"y": 3.025,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_1_5.json
// module id = 321
// module chunks = 0